import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { PageHeader } from "@/shared/components/PageHeader";
import { EquipmentTypeFormModal } from "../components/EquipmentTypeFormModal";
import { EquipmentTypeTable } from "../components/EquipmentTypeTable";
import { useEquipmentTypesStore } from "../store/equipment-types.store";

export function EquipmentTypesPage() {
	const openCreateModal = useEquipmentTypesStore((s) => s.openCreateModal);

	return (
		<div>
			<PageHeader
				title="Texnika turlari"
				action={
					<Button
						type="primary"
						icon={<PlusOutlined />}
						onClick={openCreateModal}
						id="equipment-types-create-btn"
					>
						Qo'shish
					</Button>
				}
			/>
			<EquipmentTypeTable />
			<EquipmentTypeFormModal />
		</div>
	);
}
